export default __webpack_public_path__ + "static/media/cp_geo_md.af4db83b.svg";